export const strings = {
    en: {
        'Assets in contract':'Assets in contract'
    },
    de: {
        'Assets in contract':'Anlagen im Vertrag'
    },
};